import React, {useEffect, useState} from 'react';
import {useOutside} from "../hook/useOutside";
import {NavLink} from 'react-router-dom';
import styled from 'styled-components';
import {MdClose, MdMenu} from 'react-icons/md';


const NavStyles = styled.nav`
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  padding: 1rem 0;
  background: var(--dark-bg);

  ul {
    max-width: 1200px;
    margin: 0 auto;
    width: 90%;
    text-align: center;

    li {
      display: inline-block;
      border-radius: 8px;
      transition: 0.3s ease background-color;

      &:hover {
        background-color: var(--deep-dark);
      }
    }

    a {
      display: inline-block;
      font-family: 'RobotoMono Regular', sans-serif;
      padding: 1rem 2rem;
      font-size: 2rem;
      color: var(--gray-1);
      outline: none;
    }

    .active {
      color: var(--white);
    }
  }


  .mobile-menu-icon {
    position: absolute;
    right: 1rem;
    top: 1rem;
    width: 6rem;
    cursor: pointer;
    display: none;
    outline: none;
    padding: 10px;


    * {
      pointer-events: none;
    }
  }

  .navItems .closeNavIcon {
    display: none;
  }

  @media only screen and (max-width: 768px) {
    body {
      overflow: auto;
    }

    /******************************/
    .wrap-mobile-menu-icon {
      position: fixed;
      top: 0;
      padding: 20px;
      width: 100%;
      height: 70px;
      z-index: 0;

      /*animation*/
      transition-timing-function: ease-in;
      transition: all 0.5s;

    }

    .wrap-mobile-menu-icon-substrate {
      //background: var(--deep-dark);
      background: rgb(41, 41, 41)

    }

    .wrap-mobile-menu-icon-disabled {
      display: none;
    }


    /******************************/
    padding: 0;
    .hide-item {
      transform: translateY(calc(-100% - var(--top)));
    }

    .mobile-menu-icon {
      display: block;
    }

    .navItems {


      --top: 0rem;
      -webkit-transition-timing-function: ease-in;
      transition-timing-function: ease-in;
      transition: 0.3s ease transform;
      background-color: var(--deep-dark);
      padding: 2.5rem 20px 0 0;
      width: 90%;
      max-width: 55%;
      border-radius: 12px;
      position: absolute;
      right: 0;
      top: var(--top);

      .closeNavIcon {
        display: block;
        width: 4rem;
        margin: 0 0 0 auto;
        cursor: pointer;

        * {
          pointer-events: none;
        }
      }

      li {
        display: block;
        margin-bottom: 1rem;
      }
    }
  }

  @media only screen and (max-width: 320px) {
    .mobile-menu-icon {
      width: 7rem;

    }

`;

export default function NavMenu() {
    const [showBlock, setShowBlock] = useState(false);
    // const [showNav, setShowNav] = useState(false);
    const {ref, isShow, setIsShow} = useOutside(false);

    //выполняем прокрутку сайта до мемента значений с использованием анимации
    const transitionNavBar = () => {
        (window.scrollY > 20) ? setShowBlock(true) : setShowBlock(false)
    }

    useEffect(() => {
        window.addEventListener('scroll', transitionNavBar)
        return () => {
            window.removeEventListener('scroll', transitionNavBar)
        };
    }, []);


    if (window.screen.width <= 768) {
        if (!isShow) {
            document.body.style.overflow = "auto"

        } else {
            document.body.style.overflow = "hidden"
        }
    }


    return (
        <NavStyles>
            <div className={`wrap-mobile-menu-icon ${showBlock && 'wrap-mobile-menu-icon-substrate'}`}>
                <div
                    className="mobile-menu-icon"
                    // className={`${!isShow ? 'mobile-menu-icon' : 'wrap-mobile-menu-icon-disabled'}`}
                    onClick={() => setIsShow(!isShow)}
                    role="button"
                    onKeyDown={() => setIsShow(!isShow)}
                    tabIndex={0}
                >
                    <MdMenu/>
                </div>
            </div>

            <ul className={!isShow ? 'navItems hide-item' : 'navItems'} ref={ref}>
                <div
                    className="closeNavIcon"
                    onClick={() => setIsShow(!isShow)}
                    role="button"
                    onKeyDown={() => setIsShow(!isShow)}
                    tabIndex={0}
                >

                    <MdClose/>
                </div>
                <li>
                    <NavLink
                        to="/"
                        exact
                        onClick={() => setIsShow(!isShow)}
                        role="button"
                        onKeyDown={() => setIsShow(!isShow)}
                        tabIndex={0}
                    >
                        Home
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        to="/about"
                        onClick={() => setIsShow(!isShow)}
                        role="button"
                        onKeyDown={() => setIsShow(!isShow)}
                        tabIndex={0}
                    >
                        About
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        to="/projects"
                        onClick={() => setIsShow(!isShow)}
                        role="button"
                        onKeyDown={() => setIsShow(!isShow)}
                        tabIndex={0}
                    >
                        Projects
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        to="/contact"
                        onClick={() => setIsShow(!isShow)}
                        role="button"
                        onKeyDown={() => setIsShow(!isShow)}
                        tabIndex={0}
                    >
                        Contact
                    </NavLink>
                </li>
            </ul>
        </NavStyles>
    );
}
